module.exports = __webpack_public_path__ + "img/pic_nj_mrt.89b6ad13.png";